import config from "./config";
import renderRouter from "./renderRouter";

const ArticleLibraryRoute = (): React.ReactElement => renderRouter(config);

export default ArticleLibraryRoute;
